import React, { useState } from "react"
import { Modal, Button } from "react-bootstrap"
import { deleteDoc, doc, getDoc } from "firebase/firestore"
import { db } from "../../Firebase/config"
import StarRating from "./Starrating"
import Notify from "../Componentslogic/Usenotifications"
import ReactModal from "react-modal"
import { FaWhatsapp, FaEye, FaChevronDown, FaChevronUp } from "react-icons/fa"
import View from "../images/View.svg"
ReactModal.setAppElement("#root")

export const Adminreviewscard = ({ reviews }) => {
  const [show, setShow] = useState(false)
  const [showWhatsAppModal, setShowWhatsAppModal] = useState(false)
  const [showOrderModal, setShowOrderModal] = useState(false) // Order details modal state
  const [whatsAppMessage, setWhatsAppMessage] = useState("")
  const [selectedPhone, setSelectedPhone] = useState("")
  const [orderDetails, setOrderDetails] = useState(null) // Store order details
  const [cartExpanded, setCartExpanded] = useState(false)
  const [showDineInModal, setShowDineInModal] = useState(false)
  const handleClose = () => setShow(false)

  const fetchOrderDetails = async () => {
    if (reviews.orderID) {
      try {
        const collectionName =
          reviews.type === "delivery" ? "DeliveryOrders" : "Orders"
        const orderDocRef = doc(db, collectionName, reviews.orderID) // Using orderNumber as the ID
        const orderSnapshot = await getDoc(orderDocRef)

        if (orderSnapshot.exists()) {
          setOrderDetails(orderSnapshot.data()) // Store order details

          if (reviews.type === "delivery") {
            setShowOrderModal(true)
          } else {
            setShowDineInModal(true)
          }
        } else {
          Notify("Order not found", "error")
        }
      } catch (error) {
        console.error("Error fetching order details:", error)
        Notify("Error fetching order details", "error")
      }
    } else {
      return
    }
  }

  const handleDelete = async () => {
    try {
      await deleteDoc(doc(db, "Reviews", reviews.id))
      Notify("Review deleted successfully", "success")
    } catch (error) {
      Notify("Error deleting review", "error")
      console.error(error)
    } finally {
      handleClose()
    }
  }

  const handleSendWhatsApp = () => {
    if (!whatsAppMessage.trim()) {
      Notify("Please enter a message", "error") // Ensure message isn't empty
      return
    }

    const message = encodeURIComponent(whatsAppMessage)
    const phoneNumber = selectedPhone.replace(/\D/g, "") // Remove any non-numeric characters

    // Detect if user is on a mobile device
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

    // Use WhatsApp Web on desktop, WhatsApp App on mobile
    const whatsappUrl = isMobile
      ? `https://api.whatsapp.com/send?phone=2${phoneNumber}&text=${message}` // Mobile opens WhatsApp App
      : `https://web.whatsapp.com/send?phone=2${phoneNumber}&text=${message}` // Desktop opens WhatsApp Web

    window.open(whatsappUrl, "_blank") // Opens in new tab
    setShowWhatsAppModal(false) // Close modal after sending
  }

  const handleOpenWhatsAppModal = (phone) => {
    setSelectedPhone(phone)
    setWhatsAppMessage("") // Reset message input
    setShowWhatsAppModal(true)
  }

  const handleCloseWhatsAppModal = () => {
    setShowWhatsAppModal(false)
  }

  const formatTimestamp = (timestamp) => {
    if (!timestamp || !timestamp.seconds) return "N/A" // Handle missing timestamp

    const date = new Date(timestamp.seconds * 1000) // Convert Firestore Timestamp

    // Format date as YYYY-MM-DD
    const formattedDate = date.toLocaleDateString("en-GB")

    // Format time as HH:MM AM/PM
    const formattedTime = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })

    return { formattedDate, formattedTime }
  }

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the review from {reviews.useremail}?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <tr>
        <td>{reviews.userName || "No name provided"}</td>
        <td>{reviews.userPhone || "No phone provided"}</td>
        <td>{reviews.text || "-"}</td>
        <td>
          <StarRating rating={reviews.ratingService} />
        </td>
        <td>
          <StarRating rating={reviews.ratingFood} />
        </td>
        <td>
          {new Date(reviews.createdAt.seconds * 1000).toLocaleString() || "N/A"}
        </td>
        <td>{reviews.type === "delivery" ? "Delivery" : "Dine-in"}</td>
        <td>
          {reviews.userPhone && (
            <FaWhatsapp
              size={24} // Adjust icon size
              color="green"
              className="whatsapp-icon mx-2"
              style={{ cursor: "pointer" }}
              onClick={() => handleOpenWhatsAppModal(reviews.userPhone)}
            />
          )}

          {reviews.orderID && (
            <FaEye
              size={24} // Adjust icon size
              color="Blue"
              className="whatsapp-icon mx-2"
              style={{ cursor: "pointer" }}
              onClick={() => fetchOrderDetails()}
            />
          )}
        </td>
      </tr>
      <ReactModal
        isOpen={showWhatsAppModal}
        onRequestClose={handleCloseWhatsAppModal}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <h2 className="modal-title">Send WhatsApp Message</h2>

        <div className="form-group mt-3">
          <label>Phone Number:</label>
          <input
            type="text"
            className="form-control"
            value={selectedPhone}
            disabled
          />
        </div>

        <div className="form-group mt-3">
          <label>Message:</label>
          <textarea
            className="form-control"
            rows="4"
            value={whatsAppMessage}
            onChange={(e) => setWhatsAppMessage(e.target.value)}
            placeholder="Type your message here..."
          ></textarea>
        </div>

        <div className="d-flex justify-content-end mt-4">
          <button
            className="btn btn-secondary mx-2"
            onClick={handleCloseWhatsAppModal}
          >
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleSendWhatsApp}>
            Send on WhatsApp
          </button>
        </div>
      </ReactModal>

      <ReactModal
        isOpen={showOrderModal}
        onRequestClose={() => setShowOrderModal(false)}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <h2 className="modal-title">Order Details</h2>
        {orderDetails ? (
          <div className="order-details">
            <p>
              <b>Order Number:</b> {orderDetails.orderNumber}
            </p>
            <p>
              <b>Total Amount:</b> {orderDetails.totalAmount} EGP
            </p>
            <p>
              <b>Picked By:</b> {orderDetails.PickedBy || "N/A"}
            </p>
            <p>
              <b>Picked At:</b>{" "}
              {formatTimestamp(orderDetails.pickedAt).formattedDate},{" "}
              {formatTimestamp(orderDetails.pickedAt).formattedTime}
            </p>
            <p>
              <b>Delivered By:</b> {orderDetails.DeliveredBy || "N/A"}
            </p>
            <p>
              <b>Delivered At:</b>{" "}
              {formatTimestamp(orderDetails.deliveredAt).formattedDate},{" "}
              {formatTimestamp(orderDetails.deliveredAt).formattedTime}
            </p>
            <p>
              <b>Delivery Fee:</b> {orderDetails.deliveryFee || "N/A"} EGP
            </p>
            <p>
              <b>Area:</b> {orderDetails.address?.area}
            </p>

            {/* Cart Items - Collapsible */}
            <div className="cart-section">
              <div
                className="cart-header"
                onClick={() => setCartExpanded(!cartExpanded)}
              >
                <h6>Cart Items</h6>
                {cartExpanded ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              {cartExpanded && (
                <div className="cart-items-container">
                  <ul>
                    {orderDetails.cart?.map((item, index) => (
                      <li key={index}>
                        <b>{item.name}</b> x {item.CartTotalQuantity} -{" "}
                        {item.itemTotal} EGP
                        <div className="item-options">
                          {item.spiceLevel && (
                            <span className="mx-2">
                              <b>Spice:</b> {item.spiceLevel}
                            </span>
                          )}
                          {item.combo && item.combo.name && (
                            <span>
                              <b>Combo:</b> {item.combo.name} -{" "}
                              {item.combo.Price} EGP
                            </span>
                          )}
                          {item.freeSauce && (
                            <span>
                              <b>Sauce:</b> {item.freeSauce}
                            </span>
                          )}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        ) : (
          <p>Loading order details...</p>
        )}
        <button
          className="btn btn-secondary mt-3"
          onClick={() => setShowOrderModal(false)}
        >
          Close
        </button>
      </ReactModal>

      {/* ✅ Dine-in Order Modal */}
      <ReactModal
        isOpen={showDineInModal}
        onRequestClose={() => setShowDineInModal(false)}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <h2 className="modal-title">Dine-in Order Details</h2>
        {orderDetails ? (
          <div className="order-details">
            <p>
              <b>Order Number:</b> {orderDetails.ordernumber}
            </p>
            <p>
              <b>Total Amount:</b> {orderDetails.totalAmount} EGP
            </p>

            <p>
              <b>Placed At:</b>{" "}
              {formatTimestamp(orderDetails.PlacedAt).formattedDate},{" "}
              {formatTimestamp(orderDetails.PlacedAt).formattedTime}
            </p>
            <p>
              <b>Done At:</b> {orderDetails.DoneAttime}
            </p>

            {/* ✅ Collapsible Cart Items */}
            <div className="cart-section">
              <div
                className="cart-header"
                onClick={() => setCartExpanded(!cartExpanded)}
              >
                <h6>Cart Items</h6>
                {cartExpanded ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              {cartExpanded && (
                <div className="cart-items-container">
                  <ul>
                    {orderDetails.cartItems?.map((item, index) => (
                      <li key={index}>
                        <b>{item.name}</b> x {item.CartTotalQuantity} -{" "}
                        {item.itemTotal} EGP
                        <div className="item-options">
                          {item.spiceLevel && (
                            <span className="mx-2">
                              <b>Spice:</b> {item.spiceLevel}
                            </span>
                          )}
                          {item.combo && item.combo.name && (
                            <span>
                              <b>Combo:</b> {item.combo.name} -{" "}
                              {item.combo.Price} EGP
                            </span>
                          )}
                          {item.freeSauce && (
                            <span>
                              <b>Sauce:</b> {item.freeSauce}
                            </span>
                          )}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        ) : (
          <p>Loading order details...</p>
        )}
        <button
          className="btn btn-secondary mt-3"
          onClick={() => setShowDineInModal(false)}
        >
          Close
        </button>
      </ReactModal>
    </>
  )
}
